import { api } from 'utility';
import FileSaver from 'file-saver';
import {
  getTransctionReciptHtml,
  getTransctionReciptPdf,
  getTransctionReciptReportyPdf,
  getShareReciptEmaliUrl,
  getTransctionReciptReportHtml,
  getTransctionReciptReportySettlementPdf,
  getTransctionReciptReportSettlementHtml,
} from 'URLs';

/**
 * دریافت html رسید تراکنش بصورت رشته
 */
export function financialTransctionReciptHtml(docId, params, headers) {
  return api
    .post(
      getTransctionReciptHtml(docId),
      {},
      {
        params,
        headers: {
          ...headers,
        },
      },
    )
    .then((res) => res.data);
}

export function financialTransctionReciptReportHtml(id) {
  return api.get(getTransctionReciptReportHtml(id)).then((res) => res.data);
}

export function financialTransctionReciptReportSettlmentHtml(id) {
  return api.get(getTransctionReciptReportSettlementHtml(id)).then((res) => res.data);
}
/**
 * دریافت خروجی رسید تراکنش بصورت pdf
 */
export function financialTransctionReciptPdf(docId, params) {
  return api.post(getTransctionReciptPdf(docId), {}, { params: { ...params } }).then((response) => {
    const { base64, contentType, fileName } = response.data.result;
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: contentType || 'application/pdf' });
    FileSaver.saveAs(blob, fileName || fileName || `transactionExport_${docId}.pdf`);
    return response.data;
  });
}


export function financialTransctionReciptReportyPdf(docId) {
  return api.get(getTransctionReciptReportyPdf(docId))
    .then((response) => {
      const { base64, contentType, fileName } = response.data.result;
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: contentType || 'application/pdf' });
      FileSaver.saveAs(blob, fileName || (fileName || `transactionExport_${docId}.pdf`));
      return response.data; 
    });
}

export function financialTransctionReciptSettlmentPdf(docId) {
  return api.get(getTransctionReciptReportySettlementPdf(docId))
    .then((response) => {
      const { base64, contentType, fileName } = response.data.result;
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: contentType || 'application/pdf' });
      FileSaver.saveAs(blob, fileName || (fileName || `transactionExport_${docId}.pdf`));
      return response.data; 
    });
}

/**
 * اشتراک گذاری اطلاعات و ارسال به ایمیل
 */
export function shareWithEmail(docId, data) {
  return api.post(getShareReciptEmaliUrl(docId), data, {}).then((res) => res.data);
}

export default {
  financialTransctionReciptHtml,
  financialTransctionReciptReportHtml,
  financialTransctionReciptPdf,
  financialTransctionReciptReportyPdf,
  shareWithEmail,
  financialTransctionReciptSettlmentPdf,
  financialTransctionReciptReportSettlmentHtml,
};
